require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-uganda-forest-project-stakeholder-engagement.json") })
        }
      }, "path---en-us-update-uganda-forest-project-stakeholder-engagement");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-uganda-forest-project-stakeholder-engagement!./.cache/json/en-us-update-uganda-forest-project-stakeholder-engagement.json
// module id = 815
// module chunks = 231608221292675